import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { useState } from "react";
import styled from "@emotion/styled";
import DateRangePicker from "./dateDropDown";
import { Tbox, TboxColor, TBoxText, TContainer } from "./styled";
import generateColors from "shared/utils/generateColors";

const TabComponent = styled(Tab)({
  color: "#292929",
  fontWeight: 400,
  fontSize: "16px",
  textTransform: "capitalize",
  "&.Mui-selected": {
    background: "#D7D7D799",
    borderRadius: "5px",
    color: "#292929",
  },
});

interface Props {
  value?: number;
  setValue?: Function;
  items: string[];
}

export default function TabThirdParty({ value, setValue, items }: Props) {
  // const handleChange = (event: React.SyntheticEvent, newValue: number) => {
  //   setValue(newValue);
  // };
  let distinctColors = generateColors(items.length);

  return (
    <Box
      sx={{ width: "100%", display: "flex", justifyContent: "space-between" }}
    >
      {/* <Tabs
        onChange={handleChange}
        value={value}
        aria-label='Tabs where selection follows focus'
        selectionFollowsFocus
        TabIndicatorProps={{ style: { display: "none" } }}
      >
        {items.map((item, index) => (
          <TabComponent label={item} key={`Tb${index}`} />
        ))}
      </Tabs> */}
      <TContainer>
        {items.map((item, index) => (
          <Tbox key={`T${index}`}>
            <TboxColor color={distinctColors[index]} />
            <TBoxText>{item}</TBoxText>
          </Tbox>
        ))}
      </TContainer>
      <DateRangePicker />
    </Box>
  );
}
